import { useEffect, useState } from 'react'
import ButtonEl from '../helpers/ctas/Button'
import themeConfig from '../../../theme.config'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/solid'

function Search(props) {
  const triggerTheme = 'tertiary'
  const searchTheme = 'secondary'
  const [searchActive, setSearchActive] = useState()
  const [searchTerm, setSearchTerm] = useState()

  useState(() => {
    document.addEventListener('click', (evt) => {
      if (!evt.target.closest('[data-type="search"]') && !evt.target.closest('[data-type="searchForm"]')) {
        setSearchActive(false)
      }
    })
  }, [])

  const triggerContent = (
    <>
      <MagnifyingGlassIcon
        className={`${searchActive ? 'hidden' : 'block'} h-8 w-8 text-base-text text-xl`}
        role="none"
      />
      <XMarkIcon className={`${searchActive ? 'block' : 'hidden'} h-8 w-8 text-base-text text-xl`} role="none" />
      <span className="sr-only">Toggle search field</span>
    </>
  )
  const searchContent = <span>Search</span>

  useEffect(() => {
    setSearchActive((prevState) => (props.menuActive === true || props.ctasActive === true ? false : prevState))
  }, [props.menuActive, props.ctasActive])

  const submitForm = (evt) => {
    evt.preventDefault()
    const loc = window.location
    const searchUrl = new URL(`${loc.origin}/${themeConfig.settings.searchPageStub}`)
    searchUrl.searchParams.append('q', searchTerm)
    window.location = searchUrl
  }

  const handleSearchClick = (evt) => {
    setSearchActive((prevState) => {
      const isActive = !prevState
      props.setSearchActive(isActive)
      props.setMenuActive((prevState) => {
        let newState = prevState
        if (isActive === true) {
          // is search has become active turn the menu off
          newState = false
        }
        // otherwise do nothing.
        props.setCtasActive(newState)
        return newState
      })
      return isActive
    })
  }

  return (
    <>
      <div
        data-type="search"
        className={`basis-1/10 self-center ml-auto md:ml-3 peer/trigger ${searchActive && (props.menuActive === false || props.menuActive === undefined) ? 'active' : 'inactive'}`}
      >
        <ButtonEl theme={triggerTheme} className="!px-0 !shadow-none" onClick={handleSearchClick} buttonType="default">
          {triggerContent}
        </ButtonEl>
      </div>
      <div
        data-type="searchForm"
        className={`group/wrapper ${searchActive ? 'active' : 'inactive'} absolute left-0 w-full top-[100%] flex peer-[.inactive]/trigger:h-0 transition-all z-50 duration-500 peer-[.active]/trigger:h-[100px] overflow-hidden flex-nowrap`}
      >
        <form
          className={`group/form shadow-md ${searchActive ? ' active' : 'inactive'} container mx-auto py-4 mb-4 max-md:px-8 md:px-12 basis-10/12 md:basis-7/12 mx-auto bg-${themeConfig.settings.nav.search.base} rounded-b-md`}
          onSubmit={submitForm}
          role="search"
          aria-label="Sitewide"
          id="main-nav-search"
        >
          <div className="w-full flex flex-nowrap items-center justify-center gap-4 group-[.active]/form:opacity-100 group-[.inactive]/form:opacity-0 transition-all duration-300 group-[.active]/form:delay-500">
            <input
              id="search"
              type="text"
              onChange={(e) => setSearchTerm(encodeURIComponent(e.target.value))}
              placeholder="Enter search terms"
              autoComplete="off"
              tabIndex={searchActive ? 0 : -1}
              aria-hidden={searchActive ? 'false' : 'true'}
              aria-label="Site Search"
              className="rounded-full py-3 px-5 basis-auto grow"
            />
            <ButtonEl
              active={searchActive ? true : false}
              theme={searchTheme}
              ariaHidden={searchActive ? 'false' : 'true'}
              tabIndex={searchActive ? 0 : -1}
              type="submit"
            >
              {searchContent}
            </ButtonEl>
          </div>
        </form>
      </div>
    </>
  )
}

export default Search
